export const CartRoute = {
  Cart: (): string => '/cart',
  UpdateCart: (cartNumber: number): string => `/cart/${cartNumber}`,
  MultipleUpdateCart: (cartId: number): string => `/cart/${cartId}`,
  DeleteCart: (cartNumber: number): string => `/cart/${cartNumber}`,
  DeleteCartItem: (cartNumber: number, productId: number): string =>
    `/cart/delete/${cartNumber}/item/${productId}`,
};
